export default __webpack_public_path__ + "static/media/img_1.054e6f21.jpeg";